module.exports = {
      id: "tv-usage",
      viewBox: "0 0 24.014 24",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#tv",
      toString: function () {
        return this.url;
      }
    }